export type ChangeTag = 'new' | 'improved' | 'fixed';
export type Department = 'Platform' | 'OMS' | 'AMS' | 'EPC';
export type AssetKind = 'solar' | 'wind' | 'both';
export type ReleaseStatus = 'Released' | 'Scheduled' | 'Partially released' | 'Withdrawn';
export type Visibility = 'Published' | 'Hidden';

export interface ChangeItem {
  department: Department;
  module: string;
  tag: ChangeTag;
  summary: string;
  detail?: string;
  sites?: string;
  appliesTo?: AssetKind;
  obligation?: string;
  restatesFigures?: boolean;
}

export interface ReleaseEntry {
  id?: string;
  version: string;
  date: string;
  headline: string;
  status?: ReleaseStatus;
  channel?: string;
  visibility?: Visibility;
  draft?: boolean;
  changes: ChangeItem[];
}

export const DEPARTMENTS: Department[] = ['Platform', 'OMS', 'AMS', 'EPC'];

export function releaseKey(r: Pick<ReleaseEntry, 'id' | 'version' | 'date'>): string {
  return r.id ?? `${r.version}::${r.date || 'draft'}`;
}
